import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _objectSpread from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import history from './history.vue';
import Chat from './chat/index.vue';
import { mapGetters } from 'vuex';
import { removeSessionStorage, setSessionStorage } from '@/utils/storage';
import SvgIcon from '@/components/svg-icon.vue';
export default {
  components: {
    SvgIcon: SvgIcon,
    history: history,
    Chat: Chat
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('ai', ['aiLoading'])), mapGetters('user', ['userInfo'])),
  beforeDestroy: function beforeDestroy() {
    removeSessionStorage('windowId');
    removeSessionStorage('conversationId');
    this.$store.dispatch('ai/reset');
  },
  beforeCreate: function beforeCreate() {
    var query = this.$route.query;
    var userId = query.userId ? decodeURIComponent(query.userId) : '';
    var phone = query.phone ? decodeURIComponent(query.phone) : '';
    var platform = query.from ? decodeURIComponent(query.from) : ''; // 标识从哪一个平台进入，小程序或者PC
    setSessionStorage('platform', platform);
    if (userId && phone) {
      // 存在手机号跟用户ID
      this.$store.dispatch('user/setUserInfo', {
        id: userId,
        phone: phone
      });
    } else {
      this.$store.dispatch('user/setUserInfo', {});
    }
  },
  methods: {
    handleNewChat: function handleNewChat() {
      if (this.aiLoading) {
        return _Toast({
          message: '请先停止回答!'
        });
      }
      this.$eventBus.$emit('new-conversation');
    }
  }
};